// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__25Za3","emails":"CreateEditClinics_emails__1u9Tf","emailTagLabel":"CreateEditClinics_emailTagLabel__3zfm5"};